import { GET_AIRBYTE_TOKEN } from './operations'
import type { AirbyteQueriesMap } from './types'

export const GRAPH_AIRBYTE_QUERIES: AirbyteQueriesMap = {
  getAirbyteToken: GET_AIRBYTE_TOKEN,
}
